import React from "react";
import cx from "classnames";
import "./typography.css";
import { THEME_KEY } from "Theme/ThemeProviderWrapper";
import { darkTheme } from "Theme/themeConfig";

const variantsMapping: any = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  h6F: "h6",
  headingH3: "h3",
  subheading1: "h6",
  subheading2: "h6",
  subheading3: "h6",
  subheadingSB1: "h6",
  subheadingSB2: "h6",
  semiboldheading: "h6",
  seminormalheading: "h6",
  body1: "p",
  body2: "p",
  body3: "p",
  body4: "p",
  body5: "p",
  forminfo: "p",
  label: "p",
  body5Secondary: "p",
  selectInputValue: "p",
  selectInputValueDisabled: "p",
  selectInputValueBlack: "p",
};
export interface typographyIFC {
  variant?: string;
  color?: string;
  children?: any;
  className?: string;
  style?: React.CSSProperties;
  props?: any;
}
const Typography = ({ variant, color, children, ...props }: typographyIFC) => {
  const Component = variant ? variantsMapping[variant] : "p";
  const theme = localStorage.getItem(THEME_KEY);
  console.log("themethemetheme", theme);
  return (
    <Component
      className={cx({
        [`typography--variant-${variant}`]: variant,
        [`typography--color-${theme === "dark" ? darkTheme.textColor : color}`]:
          color,
      })}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Typography;
